import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "app-cerrix-slide-out",
    templateUrl: "./cerrix-slide-out.component.html",
    styleUrls: ["./cerrix-slide-out.component.scss"],
    encapsulation: ViewEncapsulation.None,
    host: {
        "[class.active]": "isOpen",
    }
})
export class CerrixSlideOutComponent {
    @Input() isOpen: boolean = false;
    @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected close(): void {
        this.isOpenChange.emit(false);
    }
}
